export default "__VITE_ASSET__4d75c673__"